export default __webpack_public_path__ + "static/char-v-61-c55e06c58281e72fcb33727f41d76b16.webp";